import React, { Component } from 'react';
import { AppContext } from '../context/AppContext';
import {
  sendTestInboundMessage,
  getStoredChatMessages,
  saveStoredChatMessages,
} from '../services/testChatService';

class TestChatPage extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      messageText: '',
      chatMessages: [],
      errorMessage: '',
      successMessage: '',
      pollingStarted: false,
    };

    this.pollingInterval = null;
  }

  componentDidMount() {
    this.loadMessagesFromLocalStorage();
    this.startPolling();
  }

  componentWillUnmount() {
    this.stopPolling();
  }

  loadMessagesFromLocalStorage = () => {
    const storedMessages = getStoredChatMessages();

    this.setState({
      chatMessages: storedMessages,
    });
  };

  startPolling = () => {
    if (this.pollingInterval) {
      return;
    }

    this.pollingInterval = setInterval(() => {
      this.loadMessagesFromLocalStorage();
    }, 2000);

    this.setState({
      pollingStarted: true,
    });
  };

  stopPolling = () => {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  };

  handleMessageChange = (event) => {
    this.setState({
      messageText: event.target.value,
      errorMessage: '',
      successMessage: '',
    });
  };


  handleSendMessage = () => {
  const { state } = this.context;
  const { messageText } = this.state;

  const owner = state.owner || {};
  const phoneNumber = owner.phone_number || '';
  const profileName = owner.name || 'Owner';

  if (!messageText.trim()) {
    this.setState({ errorMessage: 'יש להזין הודעה' });
    return;
  }

  const currentMessage = messageText.trim();

  const userMessage = {
    id: 'msg_user_' + new Date().getTime(),
    direction: 'outbound',
    sender: 'user',
    phone_number: phoneNumber,
    profile_name: profileName,
    message: currentMessage,
    created_at: new Date().toISOString(),
  };

  this.setState(
    (prevState) => {
      const updatedMessages = [...prevState.chatMessages, userMessage];
      saveStoredChatMessages(updatedMessages);

      return {
        loading: true,
        errorMessage: '',
        successMessage: '',
        messageText: '',
        chatMessages: updatedMessages,
      };
    },
    () => {
      sendTestInboundMessage({
        phone_number: phoneNumber,
        message: currentMessage,
        profile_name: profileName,
      })
        .then((response) => {
          const replyText =
            response?.data?.data?.reply_text ||
            response?.data?.reply_text ||
            response?.data?.error ||
            'לא התקבלה תשובה מהשרת';

          const serverMessage = {
            id: 'msg_server_' + new Date().getTime(),
            direction: 'inbound',
            sender: 'assistant',
            phone_number: phoneNumber,
            profile_name: 'MBVIP',
            message: replyText,
            created_at: new Date().toISOString(),
            server_response: response?.data || response,
          };

          this.setState((prevState) => {
            const updatedMessages = [...prevState.chatMessages, serverMessage];
            saveStoredChatMessages(updatedMessages);

            return {
              loading: false,
              chatMessages: updatedMessages,
              successMessage: 'ההודעה נשלחה בהצלחה',
            };
          });
        })
        .catch((error) => {
          const errorMessage = {
            id: 'msg_error_' + new Date().getTime(),
            direction: 'inbound',
            sender: 'assistant',
            phone_number: phoneNumber,
            profile_name: 'MBVIP',
            message:
              error?.response?.data?.error ||
              error.message ||
              'שגיאה בשליחת הודעה',
            created_at: new Date().toISOString(),
          };

          this.setState((prevState) => {
            const updatedMessages = [...prevState.chatMessages, errorMessage];
            saveStoredChatMessages(updatedMessages);

            return {
              loading: false,
              errorMessage: errorMessage.message,
              chatMessages: updatedMessages,
            };
          });
        });
    }
  );
};

  /**
    
    
    handleSendMessage = () => {
    const { state } = this.context;
    const { messageText, chatMessages } = this.state;

    const owner = state.owner || {};
    const phoneNumber = owner.phone_number || '';
    const profileName = owner.name || 'Owner';

    if (!messageText.trim()) {
      this.setState({
        errorMessage: 'יש להזין הודעה',
      });
      return;
    }

    this.setState({
      loading: true,
      errorMessage: '',
      successMessage: '',
    });

    sendTestInboundMessage({
      phone_number: phoneNumber,
      message: messageText,
      profile_name: profileName,
    })
      .then((response) => {
        const newMessage = {
          id: 'msg_' + new Date().getTime(),
          direction: 'outbound',
          phone_number: phoneNumber,
          profile_name: profileName,
          message: messageText,
          created_at: new Date().toISOString(),
          server_response: response,
        };

        const updatedMessages = [...chatMessages, newMessage];
        saveStoredChatMessages(updatedMessages);

        this.setState({
          loading: false,
          messageText: '',
          chatMessages: updatedMessages,
          successMessage: 'ההודעה נשלחה בהצלחה',
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בשליחת הודעה',
        });
      });
  };
    
    */
  

  renderMessages = () => {
    const { chatMessages } = this.state;

    if (!chatMessages.length) {
      return <div className="chat-empty-state">אין הודעות עדיין</div>;
    }

    return chatMessages.map((item) => {
      const isOutbound = item.direction === 'outbound';

      return (
        <div
          key={item.id}
          className={
            isOutbound ? 'chat-message-row outbound' : 'chat-message-row inbound'
          }
        >
          <div className="chat-message-bubble">
            <div className="chat-message-text">{item.message}</div>
            <div className="chat-message-meta">
              {item.profile_name || ''} |{' '}
              {item.created_at
                ? new Date(item.created_at).toLocaleString('he-IL')
                : ''}
            </div>
          </div>
        </div>
      );
    });
  };

  render() {
    const { state } = this.context;
    const { loading, messageText, errorMessage, successMessage } = this.state;
    const owner = state.owner || {};

    return (
      <div className="simple-page">
        <div className="chat-page-card">
          <div className="products-page-header">
            <div>
              <h2>Test Chat</h2>
              <p className="page-subtitle">
                מספר שולח: <span dir="ltr">{owner.phone_number || '-'}</span>
              </p>
            </div>
          </div>

          {errorMessage && <div className="message-box error-box">{errorMessage}</div>}
          {successMessage && <div className="message-box success-box">{successMessage}</div>}

          <div className="chat-messages-container">{this.renderMessages()}</div>

          <div className="chat-input-area">
            <textarea
              className="chat-textarea"
              value={messageText}
              onChange={this.handleMessageChange}
              placeholder="כתוב הודעה..."
            />

            <button
              type="button"
              className="chat-send-btn"
              onClick={this.handleSendMessage}
              disabled={loading}
            >
              {loading ? 'שולח...' : 'שלח'}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default TestChatPage;